// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ju-0";
export var discountCodeInput = "_ju-1";